export const Animations = {
  loadingPlane: require("./lottie/loadingPlane.lottie"),
  AmongUs: require("./lottie/runningAmongUs.lottie"),
  dashboardLoading: require("./lottie/dashboard.lottie"),
};
